import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import StyledModal from '../StyledModal';
import { PERSONAL, WORK } from '../../constants';
import ToastNotification from '../ToastNotification';
import emailPropType from '../../proptypes/email';
import style from '../../style/components/profile/EmailDeleteModal.module.scss';

const EmailDeleteModal = ({
  emails,
  email,
  handleCancel,
  handleConfirm,
  isOpen,
}) => {
  const { t } = useTranslation();

  if (!email) {
    return null;
  }

  const isLastWorkEmail =
    email.emailTypes.includes(WORK) &&
    emails.filter((e) => e.emailTypes.includes(WORK)).length === 1;

  const isLastPersonalEmail =
    email.emailTypes.includes(PERSONAL) &&
    emails.filter((e) => e.emailTypes.includes(PERSONAL)).length === 1;

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={handleCancel}
      title={t('email.delete.title', { address: email.address })}
      primaryButton={{
        text: t('email.delete.button_remove'),
        action: handleConfirm,
      }}
    >
      <p>{t('email.delete.description_impact')}</p>
      {isLastWorkEmail && (
        <ToastNotification type="warning">
          <span className={style.semibold}>{email.address}</span>{' '}
          {t('email.delete.warning_lastWork')}
        </ToastNotification>
      )}
      {isLastPersonalEmail && (
        <ToastNotification type="warning">
          <span className={style.semibold}>{email.address}</span>{' '}
          {t('email.delete.warning_lastPersonal')}
        </ToastNotification>
      )}
    </StyledModal>
  );
};

EmailDeleteModal.propTypes = {
  email: emailPropType,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default EmailDeleteModal;
